import axios from 'axios';
import services from '../services/services';
const baseUrl = process.env.BASE_URL || services.baseUrl;
const DashboardController = {

    tarjetaCantidades: async (idEstablecimiento: string, fechaInicio: Date, fechaFin: Date, idSucursal: string) => {
        const url = `${baseUrl}${services.dashboardBase}/${services.dashboardTarjetaCantidades}`;
        const params: any = {
            idEstablecimiento,
            fechaInicio,
            fechaFin,
        }
        if (idSucursal) {
            params.idSucursal = idSucursal;
        }
        try {
            const res = await axios.get(url, { params });
            return res;
        }
        catch (err) {
            return err;
        }
    }
}

export default DashboardController;